module.exports = __webpack_public_path__ + "img/show_tc_text_13.aeaf56e7.png";